import { ORDER_STATUS } from "../enum/OrderStatus";

export interface DdtsAPIDetailsResponse {
    data: DdtDetailsConstructor;
}

export interface Address {
    address1: string;
    address2: string;
    city: string;
    country: string;
    state: string;
    postalCode: string;
}

interface AddressConstructor {
    address_1: string;
    address_2: string;
    city: string;
    country: string;
    state: string;
    postal_code: string;
}

export interface DdtDetailsConstructor {
    document_id: string;
    ddt_number: string;
    invoice_date: string;
    posting_date: string;
    due_date: string;
    order_number: string;
    payment_term: string;
    shipping_address: AddressConstructor;
    billing_address: AddressConstructor;
    selling_address: AddressConstructor;
}

export class DdtDetailsModel {
    documentId: string;
    ddtNumber: string;
    invoiceDate: string;
    postingDate: string;
    dueDate: string | null;
    orderNumber: string;
    paymentTerm: string;
    shippingAddress: Address;
    billingAddress: Address;
    sellingAddress: Address;

    constructor(data: DdtDetailsConstructor) {
        this.documentId = data.document_id;
        this.ddtNumber = data.ddt_number;
        this.invoiceDate = data.invoice_date;
        this.postingDate = data.posting_date;
        this.dueDate = this.parseDueDate(data.due_date);
        this.orderNumber = data.order_number;
        this.paymentTerm = data.payment_term;
        this.shippingAddress = this.mapAddress(data.shipping_address);
        this.billingAddress = this.mapAddress(data.billing_address);
        this.sellingAddress = this.mapAddress(data.selling_address);
    }

    private parseDueDate(date: string): string | null {
        if (!date || date === "0001-01-01" || date.startsWith("0001-")) {
            return null;
        }
        return date;
    }

    private mapAddress(data: AddressConstructor): Address {
        return {
            address1: data.address_1,
            address2: data.address_2,
            city: data.city,
            country: data.country,
            state: data.state,
            postalCode: data.postal_code,
        };
    }
}
